import * as z from "zod";

export const sendMagicLink = {
  name: "sendMagicLink" as const,
  input: z.object({ email: z.email(), campaignSlug: z.string().optional() }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};
